// extracted by mini-css-extract-plugin
export default {"container":"FormWarningMessage__container--23G","icon":"FormWarningMessage__icon--3Bp"};